import { BELocalizationService } from "@core/services/global/localization/be-localization.service";
import { TranslateLoader, Translation } from "@ngx-translate/core";
import { Observable, of } from "rxjs";

export class CustomTranslationLoader implements TranslateLoader {
  constructor(private localizationService: BELocalizationService) {}

  getTranslation(): Observable<Translation> {
    return of(this.localizationService.getCurrentTranslations());
  }
}
